<template>
    <footer class="footer">
        <div class="container">
            <div class="footer-row">
                <div class="footer-logo-wrap">
                    <div class="footer-logo">
                        <LogoEN v-if="locale == 'en'" height="48" />
                        <Logo v-else height="94" />
                    </div>

                    <div class="footer-social-wrap" v-if="width >= 1400">
                        <h3 class="footer-header">{{ $t('footerFollow') }}</h3>
                        <div class="footer-socials">
                            <div class="footer-social-item" v-for="(social, index) in socialList" :key="index">
                                <a v-if="social.externalUrl" class="footer-social-link"
                                    :class="social.name.toLowerCase()" :href="social.externalUrl" target="_blank" :title="social.name">
                                    <img v-if="social.iconUrl" :src="social.iconUrl" :alt="social.name" width="30"
                                        height="30" />
                                </a>
                                <a v-else-if="social.urls" class="footer-social-link" :class="social.name.toLowerCase()"
                                    :href="social.urls" :title="social.name">
                                    <img v-if="social.iconUrl" :src="social.iconUrl" :alt="social.name" width="30"
                                        height="30" />
                                </a>
                                <span v-else class="footer-social-link" :class="social.name.toLowerCase()"
                                    :href="social.urls" :title="social.name">
                                    <img v-if="social.iconUrl" :src="social.iconUrl" :alt="social.name" width="30"
                                        height="30" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footer-body">
                    <div class="footer-cards">
                        <div class="footer-card" :class="footerLinkExpand && `is-expand`">
                            <div class="footer-card-header" @click="footerLinkExpand = !footerLinkExpand">
                                <h3 class="footer-header">{{ $t('footerLink') }}</h3>
                                <div class="footer-header-arrow" v-if="width < 1024">
                                    <span class="material-symbols-outlined">add</span>
                                </div>
                            </div>

                            <div class="footer-card-body">
                                <ul class="footer-nav">
                                    <li class="footer-nav-item" v-for="(item, index) in linkList" :key="index">
                                        <a v-if="item.url" class="footer-nav-link" :href="item.url">{{ item.name }}</a>
                                        <a v-else-if="item.externalUrl" class="footer-nav-link" :href="item.externalUrl" target="_blank">
                                            <span class="footer-nav-text">{{ item.name }}</span>
                                            <span class="footer-nav-icon material-symbols-outlined">call_made</span>

                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="footer-card" :class="footerDepartmentExpand && `is-expand`">
                            <div class="footer-card-header" @click="footerDepartmentExpand = !footerDepartmentExpand">
                                <h3 class="footer-header">{{ $t('footerDepartment') }}</h3>
                                <div class="footer-header-arrow" v-if="width < 1024">
                                    <span class="material-symbols-outlined">add</span>
                                </div>
                            </div>
                            <div class="footer-card-body">
                                <ul class="footer-department">
                                    <li class="footer-department-item" v-for="(item, index) in departmentList"
                                        :key="index">
                                        <h3 class="footer-department-title">{{ item.name }}</h3>
                                        <div class="footer-department-text">{{ item.tel }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="footer-card" :class="footerContactExpand && `is-expand`">
                            <div class="footer-card-header" @click="footerContactExpand = !footerContactExpand">
                                <h3 class="footer-header">{{ $t('footerContact') }}</h3>
                                <div class="footer-header-arrow" v-if="width < 1024">
                                    <span class="material-symbols-outlined">add</span>
                                </div>
                            </div>

                            <div class="footer-card-body">
                                <ul class="footer-info">
                                    <li class="footer-info-item" v-for="(item, index) in infoList" :key="index">{{
                                            item.name
                                    }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="footer-social-wrap" v-if="width < 1400">
                        <h3 class="footer-header">{{ $t('footerFollow') }}</h3>
                        <div class="footer-socials">
                            <div class="footer-social-item" v-for="(social, index) in socialList" :key="index">
                                <a v-if="social.externalUrl" class="footer-social-link"
                                    :class="social.name.toLowerCase()" :href="social.externalUrl" target="_blank" :title="social.name">
                                    <img v-if="social.iconUrl" :src="social.iconUrl" :alt="social.name" width="30"
                                        height="30" />
                                </a>
                                <a v-else-if="social.urls" class="footer-social-link" :class="social.name.toLowerCase()"
                                    :href="social.urls" :title="social.name">
                                    <img v-if="social.iconUrl" :src="social.iconUrl" :alt="social.name" width="30"
                                        height="30" />
                                </a>
                                <span v-else class="footer-social-link" :class="social.name.toLowerCase()"
                                    :href="social.urls" :title="social.name">
                                    <img v-if="social.iconUrl" :src="social.iconUrl" :alt="social.name" width="30"
                                        height="30" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="footer-bottom">
                <ul class="footer-bottom-nav order-md-2">
                    <li class="footer-bottom-nav-item" v-for="(item, index) in legalList" :key="index">
                        <a class="footer-bottom-nav-link" :href="item.url">{{ item.name }}</a>
                    </li>
                </ul>

                <div class="footer-bottom-copyright order-md-1">{{ copyright }}</div>
            </div>
        </div>
    </footer>
</template>

<script>

import Logo from '../components/Logo.vue'
import LogoEN from '../components/LogoEN.vue'

export default {
    components: { Logo, LogoEN },
    props: ['locale', 'languages', 'isAuth', 'copyright', 'legalList', 'socialList', 'linkList', 'departmentList', 'infoList'],

    data() {
        return {
            width: null,

            footerLinkExpand: false,
            footerDepartmentExpand: false,
            footerContactExpand: false,
        }
    },

    mounted() {
        this.onInit()
    },

    destroyed() {
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.resizeHandler);
            window.removeEventListener("scroll", this.scrollHandler);
        }
    },

    methods: {
        activeDesktopMenuHandle() {
            this.$store.dispatch('setSegmentPersonnelModal', !this.activeDesktopMenu)
        },

        onInit() {
            if (typeof window !== "undefined") {
                this.resizeHandler();
                this.scrollHandler();

                window.addEventListener("resize", this.resizeHandler);
                window.addEventListener("scroll", this.scrollHandler);
            }
        },
        resizeHandler() {
            this.width = window.innerWidth


            // this.isMenuRed = this.width >= 1780
            // this.isMenuRight = this.width >= 900
            // this.isMenuDesktop = this.width >= 900

            // if (this.width >= 900) {
            //     this.isActiveMobileMenu = false
            // }

            // this.$store.commit("ui/SET_WIDTH", window.innerWidth);
        },
        scrollHandler() {
            // this.$store.commit("ui/SET_SCROLLY", window.scrollY);
        },

    }
}
</script>

<style lang="scss" scoped>
.container {
    padding-left: 15px;
    padding-right: 15px;
}

.footer {
    background-color: var(--footer-bg, #712d7d);
    color: var(--footer-color, #fff);

    padding-top: 30px;
    padding-bottom: 30px;
}

.footer-header {
    font-size: var(--footer-header-font-size, 24px);
    font-weight: bold;
    letter-spacing: 2.4px;
    font-weight: bold;
    margin-bottom: 0;
}

.footer-nav {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
}

.footer-nav-item {
    margin: 0;
    padding: 0;
    display: flex;
    position: relative;
}

.footer-nav-link {
    color: var(--footer-link-color, #fff);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;

    .footer-nav-icon{
        font-size: 15px;
    }

    &:hover {
        color: var(--footer-link-hover-color, #c32237);
    }
}

.footer-bottom {
    width: 100%;
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    // justify-content: space-between;
}

.footer-bottom-nav {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    margin: 0;
}

.footer-bottom-nav-item {
    display: block;
    padding: 0;
    margin: 0;
}

.footer-bottom-nav-link {
    color: var(--footer-link-color, #fff);
    text-decoration: none;
    display: inline-flex;

    &:hover {
        color: var(--footer-link-color, #fff);
        text-decoration: none;
    }
}

.footer-department {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    gap: 15px;
}

.footer-department-item {
    padding: 0;
    margin: 0;
    display: block;
    font-size: 18px;
}

.footer-department-title {
    font-size: 90%;
    margin: 0;
    color: rgb(255 255 255 / 85%);
}

.footer-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0;
    margin: 0;
}

.footer-info-item {
    padding: 0;
    margin: 0;
    display: block;
}

.footer-socials {
    display: flex;
    gap: 10px;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
}

.footer-social-link {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 30px;

    padding: 4px;

    &:hover {
        box-sizing: 3px 3px 0 #000;
    }

    svg {
        width: 30px;
        height: 30px;
    }
}

.footer-card-header {
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;


    padding-right: 10px;

    .footer-header {
        flex: 1;
    }

    .footer-header-arrow {
        width: 24px;
        height: 24px;

        display: flex;
        justify-content: center;
        align-items: center;
        transition: transform .3s ease;
    }
}

.footer-row {
    display: flex;
    flex-direction: column;
}

// .footer-body {
//     padding-left: 20px;
//     padding-right: 20px;
// }
.footer-body .footer-social-wrap {
    padding-top: 15px;
    margin-bottom: 15px;
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;

    .footer-header {
        margin-bottom: 10px;
    }
}

.footer-logo {
    width: 100%;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;

    img {
        width: 100%;
    }

    svg {
        width: 100%;
        height: auto;
    }
}

.footer-logo-wrap {
    margin-bottom: 30px;

    .footer-social-wrap {
        display: none;
    }
}

.footer-cards {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
}

.footer-card {
    border-bottom: 1px solid rgb(255 255 255 / 20%);

    &.is-expand {
        padding-bottom: 15px;

        .footer-header-arrow {

            transform: rotate(45deg) scale(1.08);
        }

        .footer-card-body {
            display: block;
            // padding-bottom: 15px;
            // padding-left: 15px;
        }

    }
}

.footer-card-body {
    display: none;
}

@media (min-width: 768px) {
    .footer-bottom-nav {
        flex-direction: row;
        gap: 20px;
    }

    // .footer-cards {
    //     max-width: 860px;
    // }


}

@media (min-width: 1024px) {
    .footer-logo {
        max-width: 400px;
    }

    .footer-bottom {
        max-width: 1200px;
    }

    .footer-body .footer-social-wrap {
        max-width: 1200px;
    }

    .footer-cards {
        display: flex;
        max-width: 1200px;
        // margin-right: unset;

        .footer-card {
            flex-basis: 0;
            flex-grow: 1;
            max-width: 100%;
        }
    }

    .footer-card-body {
        display: block;
    }

    .footer-card-header {
        cursor: default;
    }

    .footer {
        padding-top: 60px;
        padding-bottom: 60px;
    }

    .footer-logo-wrap {
        min-width: 420px;
    }

    .footer-logo {
        margin-bottom: 60px;
    }

    .footer-nav-link {
        transition: transform 0.25s cubic-bezier(0.15, 0.15, 0, 1) 50ms;

        &:hover {
            // opacity: 0.9;
            transform: translateX(8px);
            color: var(--footer-link-hover-color, #c32237);
            text-shadow: 2px 2px 0 #000;
        }
    }

    .footer-nav-item {
        position: relative;
        transition: transform 250ms cubic-bezier(0.15, 0.15, 0, 1) 0s;
        padding-left: 15px;
        margin-bottom: 8px;

        &::before {
            content: "";
            width: 5px;
            height: 1px;
            background-color: #fff;
            left: 0;
            z-index: 1;
            transition: all 0.25s cubic-bezier(0.15, 0.15, 0, 1) 50ms;
            transform-origin: left center;
            position: absolute;
            top: 12px;
        }

        &:hover {
            &::before {
                height: 1px;
                width: 10px;
                background-color: var(--footer-link-hover-color, #c32237);
            }
        }
    }

    .footer-bottom {
        margin-top: 100px;
        justify-content: space-between;
    }

    .footer-department-item {
        position: relative;
        transition: transform 0.25s cubic-bezier(0.15, 0.15, 0, 1) 0s;
        padding-left: 15px;
        margin-bottom: 8px;

        &::before {
            content: "";
            width: 5px;
            height: 1px;
            background-color: #fff;
            left: 0;
            z-index: 1;
            transition: all 0.25s cubic-bezier(0.15, 0.15, 0, 1) 50ms;
            transform-origin: left center;
            position: absolute;
            top: 12px;
        }
    }

    .footer-header {
        color: #fff;
        // color: #031927;
        position: relative;
        // padding-bottom: 6px;

        &::before {
            content: "";
            width: 30px;
            height: 3px;
            background-color: #fff;
            position: absolute;
            left: 0;
            top: 100%;

            margin-top: 4px;
        }
    }

    .footer-socials {
        margin-top: 25px;
    }

    .footer-bottom-nav {
        gap: 25px;
    }

    .footer-bottom-nav-link {
        transition: color 0.25s cubic-bezier(0.15, 0.15, 0, 1) 0s;

        &:hover {
            color: var(--footer-link-hover-color, #c32237);
            text-shadow: 2px 2px 0 #000;
        }
    }

    .footer-socials {
        gap: 10px;
    }

    .footer-social-link {
        width: 40px;
        height: 40px;
        transition: all 0.25s cubic-bezier(0.15, 0.15, 0, 1) 0s;

        img {
            width: 30px;
            height: 30px;
        }

        // &.facebook {
        //     background-color: #365094;
        // }

        // &.youtube {
        //     background-color: #e60000;
        // }

        // &.line {
        //     background-color: #39cd00;
        // }

        // &.instagram {
        //     background-image: url("../../images/instagram.svg");
        //     background-position: center;
        //     background-repeat: no-repeat;
        //     background-size: 120%;
        // }

        // &:hover {
        //     box-shadow: 3px 3px 0 #131313;
        // }
    }

    .footer-card {
        border-bottom: none;
    }
}

@media (min-width: 1400px) {
    .footer-row {
        padding-left: 20px;
        padding-right: 20px;
    }

    .footer-row,
    .footer-bottom {
        flex-direction: row;
    }

    .footer-cards,
    .footer-bottom {
        max-width: 100%;
    }

    .footer-body {
        flex: 1 0 0%;
        padding-left: 0;
        padding-right: 0;
    }

    .footer-logo {
        display: inline-flex;
        max-width: 300px;
    }

    .footer-logo-wrap {
        .footer-social-wrap {
            display: block;
        }
    }

    .footer-bottom {
        margin-top: 150px;
    }
}
</style>